import React, { useRef, useState, useEffect } from "react";
import SearchDropdown from "components/DropDown/SearchDropdown";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { ReactComponent as SearchIcon } from "assets/icons/search_main.svg";
import useSearch from "hooks/useSearch";

const SearchInput = () => {
  const {
    selectedLocations,
    searchTerm,
    handleSearchChange,
    openSearchDropdown,
    handleRemoveLocation,
  } = useSearch();
  const inputRef = useRef();

  return (
    <div
      onClick={openSearchDropdown}
      className="flex border border-[#D0D5DD] rounded-[8px] px-[14px] relative bg-[#F5F5F5] h-[44px] w-full sm:w-auto sm:min-w-[500px] items-center space-x-[6px] mr-3"
    >
      <SearchIcon
        className="cursor-pointer text-[#667085]"
        width={20}
        height={20}
      />
      <div className="flex-1 h-full flex items-center justify-start space-x-2">
        {selectedLocations.length > 0 && (
          <div className="flex px-[7px] py-[4px] max-w-[180px] xs:max-w-[280px] cursor-pointer items-center space-x-2 bg-[#456AF21A]  rounded-[5px] h-[32px]">
            <p className="text-[#456AF2] text-[18px] truncate flex-1 font-[200] ">
              {selectedLocations.length > 1
                ? `Milano • ${selectedLocations.length} zone selezionate`
                : selectedLocations[0].name}
            </p>
            <div
              onClick={handleRemoveLocation}
              className="!w-[14px] min-w-[14px] !h-[14px] rounded-full bg-[#EFE9F6] flex items-center justify-center"
            >
              <CloseIcon width={8} height={8} fill="#456AF2" />
            </div>
          </div>
        )}
        <input
          className="outline-none w-full bg-transparent"
          placeholder={selectedLocations.length < 1 ? "Cerca" : ""}
          ref={inputRef}
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <SearchDropdown
          dropdonwStyle={{
            top: 47,
            borderRadius: "10px",
            marginLeft: 0,
          }}
        />
      </div>
    </div>
  );
};

export default SearchInput;
